// extracted by mini-css-extract-plugin
export default {"hoursLine":"HoursCard_hoursLine_EfeTF","hours":"HoursCard_hours_XRDSG","applied":"HoursCard_applied_cuNPt","needed":"HoursCard_needed_xD1Cc"};